import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "stretch",
    gap: theme.spacing.space24,
    flexDirection: "column",
  },
  serviceItem: {
    display: "flex",
    width: 310,
    minWidth: 310,
    height: 320,
  },
  username: {
    padding: `0px ${theme.spacing.space16}px`,
  },
}));
